export default {
	navigationSelector: { 
		width: '20%', 
		marginBottom: '40px'
	}
}